import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {useDispatch, useSelector} from "react-redux";
import {getTopics} from "../../../store/topicSlice";
import {Link} from "react-router-dom";
import {Button} from "@mui/material";
import {BottomAcc, Check, Exit, FileWord, LockAcc, NoCheck, TopAcc, Video} from "../../../ui/icons";
import {logout} from "../../../store/authSlice";

const ButtonAcc = styled.button`
    @media (max-width: 1032px) {
        display: block;
        flex-direction: column;
    }
`;

const SideBar = ({setVideo, video,setIdTopic}) => {
    const dispatch = useDispatch();
    const [checked, setChecked] = useState('');
    const {items, loading, error} = useSelector((state) => state.topics);
    const [openAccordion, setOpenAccordion] = useState(0);
    const toggleAccordion = (index) => {
        setOpenAccordion(openAccordion === index ? null : index);
    };
    useEffect(() => {
        dispatch(getTopics());
    }, [dispatch]);
    useEffect(() => {
        if (items.length > 0 && items[0].topic.lectures.length > 0 && items[0].topic.lectures[0].video) {
            setChecked(items[0].topic.lectures[0].video);
            setVideo(items[0].topic.lectures[0].video);
        }
        if (items.length > 0 && items[0]?.topic?.lectures[0]?.questions?.length > 0) {
            setIdTopic(items[0].topic.lectures[0]);
        }
    }, [items]);
    if (loading) return <p>loading...</p>;
    if (error) return <p>Error: {error}</p>;
    return (
        <>
            <div className='w-[100%] first-letter:'>
                <div className='flex items-center justify-between pt-[20px] sm:pt-0 text-[20px] px-0 sm:px-4'>
                    <h2 className='text-lg font-semibold py-2'>Inaugural Lecture</h2>
                    <div className='hidden sm:block'>
                        <Exit/>
                    </div>
                </div>
                <div className='flex sm:hidden text-sm justify-between items-center pt-2 pb-4 text-[14px]'>
                    <p>{items.length}</p>
                    <p> 66 Lectures</p>
                    <p>Total duration: 56 hours <br/> 18 minutes</p>
                </div>
                <div className='rounded-xl sm:rounded-none bg-[#f7f7f7]'>
                    {
                        items.map((item, index) => (
                            <div key={index}>
                                <ButtonAcc
                                    onClick={() => {
                                        toggleAccordion(item?.is_open ? item.topic.id : "")
                                    }}
                                    style={{border: '1px solid #e1e1e1'}}
                                    className={` flex flex-col text-sm py-4 px-4 text-left bg-[#f7f7f7] focus:outline-none justify-between w-full rounded-none sm:rounded-none`}
                                >
                                    <div className="flex items-center justify-between w-full">
                                        <div className='flex gap-[10px]'>
                                            {
                                                !item.is_open ?
                                                    <div>
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M6 10V8C6 4.69 7 2 12 2C17 2 18 4.69 18 8V10"
                                                                  stroke="#292D32"
                                                                  strokeWidth="1.5" strokeLinecap="round"
                                                                  strokeLinejoin="round"/>
                                                            <path
                                                                d="M12 18.5C13.3807 18.5 14.5 17.3807 14.5 16C14.5 14.6193 13.3807 13.5 12 13.5C10.6193 13.5 9.5 14.6193 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5Z"
                                                                stroke="#292D32" strokeWidth="1.5" strokeLinecap="round"
                                                                strokeLinejoin="round"/>
                                                            <path
                                                                d="M17 22H7C3 22 2 21 2 17V15C2 11 3 10 7 10H17C21 10 22 11 22 15V17C22 21 21 22 17 22Z"
                                                                stroke="#292D32" strokeWidth="1.5" strokeLinecap="round"
                                                                strokeLinejoin="round"/>
                                                        </svg>
                                                    </div>
                                                    : ""
                                            }

                                            <div>
                                                <p className="font-medium">{item.topic.title}</p>
                                                <div className='flex items-center gap-[6px] w-full'>
                                                    <span>
                                                        <svg width="3" height="4" viewBox="0 0 3 4"
                                                             fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <circle opacity="0.7" cx="1.5" cy="2" r="1.5" fill="#1E1E1E"
                                                                    fillOpacity="0.3"/>
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            {openAccordion === item?.topic?.id ? <TopAcc/> : <BottomAcc/>}
                                        </div>
                                    </div>
                                    {/*<div className="flex items-center justify-start gap-5">*/}
                                    {/*    <p className="font-normal">1 lecture</p>*/}
                                    {/*    <p className="font-medium"><span*/}
                                    {/*        className="text-[#1E1E1E] opacity-80">Teacher:</span> {item.teacher_name}*/}
                                    {/*    </p>*/}
                                    {/*</div>*/}
                                </ButtonAcc>
                                {openAccordion === item?.topic?.id &&
                                    item.topic.lectures.map((lecture) => (
                                        <div key={lecture.video} onClick={() => {
                                            if(lecture.video) {
                                                setChecked(lecture.video);
                                            }
                                            setVideo(lecture.video);
                                            setIdTopic(lecture)
                                        }}
                                             className={`p-4 flex gap-2 ${checked === lecture.video || checked === lecture.id ? 'bg-[#FFE6E6]' : 'bg-[#FFF]'}`}>
                                            <label className="flex cursor-pointer">
                                                <input type="checkbox" onChange={() => setChecked(lecture.video ? lecture.video : lecture.id)} className="hidden"/>
                                                <div className='w-[24px] h-[24px]'>
                                                    {checked === lecture.video || checked === lecture.id ? <Check/> : <NoCheck/>}
                                                </div>
                                            </label>
                                            <div className='grid gap-1 w-full'>
                                                <div className="text-sm flex items-center justify-between w-full">
                                                    <span className='text-[16px] mb-[6px]'>lecture:{lecture.title}</span>
                                                    {
                                                        lecture.video ? <Button size='small' className='!text-[#1E1E1E4D] flex items-center gap-1 rounded-lg mb-[6px]'>
                                                            <Video size={20}/>{Math.round(lecture.duration)} min
                                                        </Button>  : ""
                                                    }

                                                </div>
                                                <div className="text-sm flex items-center gap-[8px]">
                                                    <p className='text-[14px]'>Material:</p>
                                                    <div className={`flex items-center gap-1 rounded-lg ${checked === lecture.video || checked === lecture.id ? "bg-[#FFF]" : "bg-[#BA7373]"} px-2 py-1`}>

                                                        {
                                                            lecture.video ? <button className={`${checked === lecture.video || checked === lecture.id ? "text-black" : "text-white"}`}>start video</button> : <>
                                                                <div>
                                                                    <FileWord/>
                                                                </div>
                                                                <Link target={"_blank"} to={lecture.material} download className={`${checked === lecture.video || checked === lecture.id ? "text-[#000]" : "text-[#FFF]"}`}>
                                                                    {lecture.material_name}
                                                                </Link>
                                                            </>
                                                        }

                                                    </div>
                                                </div>
                                                <p className='text-black flex items-center gap-1 text-[14px]'>
                                                    {
                                                        lecture.teacher_name ? `Teacher: ${lecture.teacher_name}` : ""
                                                    }

                                                </p>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        ))
                    }
                </div>

            </div>
            {/*<div className='w-[100%]'>*/}
            {/*    {*/}
            {/*        items.map((item, index) => (*/}
            {/*            <div key={index}>*/}
            {/*                <ButtonAcc*/}
            {/*                    onClick={() => toggleAccordion(index)}*/}
            {/*                    className={` flex text-sm py-4 px-4 text-left bg-gray-100 focus:outline-none items-center justify-between w-full */}
            {/*                                ${index === 0 ? "rounded-t-lg" : ""} `}*/}
            {/*                >*/}
            {/*                    <div className="flex gap-4 items-center">*/}
            {/*                        {openAccordion === index ? <TopAcc/> : <BottomAcc/>}*/}
            {/*                        <p className="font-medium">{item.name}</p>*/}
            {/*                    </div>*/}
            {/*                    <div className="flex items-center gap-5 justify-end sm:justify-end">*/}
            {/*                        <p className="font-normal">1 lecture</p>*/}
            {/*                        <p className="font-medium"><span*/}
            {/*                            className="text-[#1E1E1E] opacity-80">Teacher:</span> {item.teacher_name}</p>*/}
            {/*                        <LockAcc/>*/}
            {/*                    </div>*/}
            {/*                </ButtonAcc>*/}
            {/*                {openAccordion === index && (*/}
            {/*                    <div>*/}
            {/*                        <hr className="h-[2px] w-[95%] bg-gray-400 opacity-80 mx-auto"/>*/}
            {/*                        <div className="text-gray-700 py-3 pl-5 text-sm">*/}
            {/*                            <p className='flex items-center'>*/}
            {/*                                Meterial:*/}
            {/*                                <Link target={"_blank"} to={item.material}>*/}
            {/*                                    <div*/}
            {/*                                        className="rounded-xl bg-[#BA7373] flex items-center gap-2 p-[7px_14px] text-white hover:text-amber-100">*/}
            {/*                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none"*/}
            {/*                                             xmlns="http://www.w3.org/2000/svg">*/}
            {/*                                            <path*/}
            {/*                                                d="M18.0041 1.875H6.06594C5.96806 1.87476 5.87109 1.89383 5.7806 1.93114C5.6901 1.96844 5.60786 2.02325 5.53859 2.0924C5.46932 2.16155 5.41438 2.2437 5.37693 2.33413C5.33947 2.42456 5.32023 2.5215 5.32031 2.61938V5.9375L12.2384 7.96875L18.7503 5.9375V2.61938C18.7504 2.52145 18.7311 2.42446 18.6936 2.33399C18.6561 2.24352 18.6012 2.16134 18.5318 2.09218C18.4625 2.02302 18.3802 1.96823 18.2896 1.93096C18.199 1.89369 18.102 1.87467 18.0041 1.875Z"*/}
            {/*                                                fill="#41A5EE"/>*/}
            {/*                                            <path*/}
            {/*                                                d="M18.7503 5.9375H5.32031V10L12.2384 11.2188L18.7503 10V5.9375Z"*/}
            {/*                                                fill="#2B7CD3"/>*/}
            {/*                                            <path*/}
            {/*                                                d="M5.32031 10V14.0625L11.8316 14.875L18.7503 14.0625V10H5.32031Z"*/}
            {/*                                                fill="#185ABD"/>*/}
            {/*                                            <path*/}
            {/*                                                d="M6.06594 18.125H18.0034C18.1014 18.1254 18.1985 18.1065 18.2892 18.0692C18.3798 18.032 18.4622 17.9772 18.5316 17.908C18.601 17.8389 18.656 17.7567 18.6936 17.6662C18.7311 17.5756 18.7504 17.4786 18.7503 17.3806V14.0625H5.32031V17.3806C5.32023 17.4785 5.33947 17.5754 5.37693 17.6659C5.41438 17.7563 5.46932 17.8384 5.53859 17.9076C5.60786 17.9768 5.6901 18.0316 5.7806 18.0689C5.87109 18.1062 5.96806 18.1252 6.06594 18.125Z"*/}
            {/*                                                fill="#103F91"/>*/}
            {/*                                            <path opacity="0.1"*/}
            {/*                                                  d="M10.2716 5.12549H5.32031V15.2817H10.2716C10.4689 15.2808 10.6578 15.2021 10.7975 15.0627C10.9372 14.9234 11.0163 14.7347 11.0178 14.5374V5.86986C11.0163 5.67257 10.9372 5.48381 10.7975 5.34448C10.6578 5.20515 10.4689 5.12647 10.2716 5.12549Z"*/}
            {/*                                                  fill="black"/>*/}
            {/*                                            <path opacity="0.2"*/}
            {/*                                                  d="M9.86469 5.53125H5.32031V15.6875H9.86469C10.062 15.6865 10.2509 15.6078 10.3906 15.4685C10.5303 15.3292 10.6095 15.1404 10.6109 14.9431V6.27562C10.6095 6.07834 10.5303 5.88958 10.3906 5.75024C10.2509 5.61091 10.062 5.53223 9.86469 5.53125Z"*/}
            {/*                                                  fill="black"/>*/}
            {/*                                            <path opacity="0.2"*/}
            {/*                                                  d="M9.86469 5.53125H5.32031V14.875H9.86469C10.062 14.874 10.2509 14.7953 10.3906 14.656C10.5303 14.5167 10.6095 14.3279 10.6109 14.1306V6.27562C10.6095 6.07834 10.5303 5.88958 10.3906 5.75024C10.2509 5.61091 10.062 5.53223 9.86469 5.53125Z"*/}
            {/*                                                  fill="black"/>*/}
            {/*                                            <path opacity="0.2"*/}
            {/*                                                  d="M9.45781 5.53125H5.32031V14.875H9.45781C9.6551 14.874 9.84406 14.7953 9.98375 14.656C10.1234 14.5167 10.2026 14.3279 10.2041 14.1306V6.27562C10.2026 6.07834 10.1234 5.88958 9.98375 5.75024C9.84406 5.61091 9.6551 5.53223 9.45781 5.53125Z"*/}
            {/*                                                  fill="black"/>*/}
            {/*                                            <path*/}
            {/*                                                d="M1.99625 5.53125H9.4575C9.65515 5.53109 9.84477 5.6094 9.9847 5.74898C10.1246 5.88856 10.2034 6.07799 10.2038 6.27563V13.7244C10.2034 13.922 10.1246 14.1114 9.9847 14.251C9.84477 14.3906 9.65515 14.4689 9.4575 14.4688H1.99625C1.89832 14.4691 1.80128 14.4501 1.71072 14.4128C1.62015 14.3755 1.53784 14.3207 1.4685 14.2516C1.39916 14.1824 1.34417 14.1002 1.30667 14.0098C1.26918 13.9193 1.24992 13.8223 1.25 13.7244V6.27563C1.24992 6.1777 1.26918 6.08071 1.30667 5.99024C1.34417 5.89977 1.39916 5.81759 1.4685 5.74843C1.53784 5.67927 1.62015 5.62448 1.71072 5.58721C1.80128 5.54994 1.89832 5.53092 1.99625 5.53125Z"*/}
            {/*                                                fill="url(#paint0_linear_1228_21048)"/>*/}
            {/*                                            <path*/}
            {/*                                                d="M4.31289 11.2427C4.32747 11.3577 4.33706 11.4579 4.34164 11.5433H4.35914C4.36539 11.4621 4.37893 11.3642 4.39977 11.2496C4.43102 11.0777 4.43852 11.0383 4.45539 10.9589L5.23977 7.57957H6.25477L7.06727 10.9083C7.11419 11.1143 7.148 11.3231 7.16852 11.5333H7.18227C7.19786 11.3287 7.22604 11.1251 7.26664 10.9239L7.91602 7.5752H8.83914L7.69914 12.4177H6.61977L5.84664 9.21395C5.82414 9.12145 5.79872 9.00103 5.77039 8.85269C5.74206 8.70436 5.72456 8.59603 5.71789 8.5277H5.70477C5.69602 8.60645 5.67852 8.72332 5.65227 8.87832C5.62602 9.03332 5.60518 9.14832 5.58977 9.22332L4.86289 12.4196H3.76539L2.61914 7.57957H3.55664L4.26352 10.9658C4.28412 11.0573 4.3006 11.1497 4.31289 11.2427Z"*/}
            {/*                                                fill="white"/>*/}
            {/*                                            <defs>*/}
            {/*                                                <linearGradient id="paint0_linear_1228_21048" x1="2.80875"*/}
            {/*                                                                y1="4.94625" x2="8.645" y2="15.0538"*/}
            {/*                                                                gradientUnits="userSpaceOnUse">*/}
            {/*                                                    <stop stop-color="#2368C4"/>*/}
            {/*                                                    <stop offset="0.5" stop-color="#1A5DBE"/>*/}
            {/*                                                    <stop offset="1" stop-color="#1146AC"/>*/}
            {/*                                                </linearGradient>*/}
            {/*                                            </defs>*/}
            {/*                                        </svg>*/}
            {/*                                        <span>*/}
            {/*                                        Lecture1: {item.name}*/}
            {/*                                    </span>*/}
            {/*                                    </div>*/}
            {/*                                </Link>*/}
            {/*                            </p>*/}
            {/*
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                )}*/}
            {/*            </div>*/}
            {/*        ))*/}
            {/*    }*/}

            {/*</div>*/}
        </>

    );
};

export default SideBar;
